/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router'; 

import {UserService} from '../../../../@core/data/users.service'
@Component({
  selector: 'nb-reset-password-page',
  styleUrls: ['./reset-password.component.scss'],
  templateUrl: './reset-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordComponent {

  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = '';

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};

  constructor(protected UserService :UserService,
              protected router: Router,
              protected activatedRoute:ActivatedRoute ,
              
              ) { 
  }
ngOnInit(){
  this.user = {
     
    pass: ''
  }
}
  resetPass(): void {
    this.errors = this.messages = [];
    this.submitted = true; 
    this.activatedRoute.queryParams.subscribe(params => {
      let date = params['u'];
     
      console.log(date); // Print the parameter to the console. 
      console.log(params['c'])
  }); 
    //get the code on the header 
    console.log(this.user.pass)

  // this.UserService.resetPassword(this.user.email,"code","okok").subscribe((result) =>{

// console.log(result);
  // })




}
    // formData.user.password


    // this.service.resetPassword(this.strategy, this.user).subscribe((result: NbAuthResult) => {
    //   this.submitted = false;
    //   if (result.isSuccess()) {
    //     this.messages = result.getMessages();
    //   } else {
    //     this.errors = result.getErrors();
    //   }

    //   const redirect = result.getRedirect();
    //   if (redirect) {
    //     setTimeout(() => {
    //       return this.router.navigateByUrl(redirect);
    //     }, this.redirectDelay);
    //   } 
    // });
  }

   
 
